module.exports = __webpack_public_path__ + "static/hamoc-f6dc2a9931a817e8aa97c8a986e05ba6.jpg";